import { PageTitle as EPPageTitle } from "@entur-partner/common";
import { useLocation } from "@tanstack/react-router";

import { useBreadcrumbLookup } from "./breadcrumbs/breadcrumbLookup.ts";

export function PageTitle() {
  const breadcrumbLookup = useBreadcrumbLookup();
  const { pathname } = useLocation();
  return <EPPageTitle pathname={pathname} onBreadcrumbLookup={breadcrumbLookup} />;
}
